import type { FC} from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguageCode } from '../../../../../../store/app/appStore';
import { testIds } from '../../../../../../core/testIds';

import styles from './NewGameBanner.module.css';

const NewGameBanner: FC = () => {
  const { t } = useTranslation();
  const currentLang = useLanguageCode();

  const isCJK = useMemo(() => ['CS', 'HU', 'KO', 'SK', 'UK', 'ZH-CN']
    .includes(currentLang), [currentLang]);

  return (
    <div className={styles.badge} data-lang={isCJK ? 'cjk' : 'default'} data-testid={testIds.games.newGameBadge}>
      {t('generic_new', 'new').toUpperCase()}
    </div>
  );
};

export default NewGameBanner;